<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="document_template_list" :search="search"
                class="elevation-1 mytable" dense>
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Document Template</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"></span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"></v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-dialog v-model="dialog" max-width="1200px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Document Template</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid" ref="form">                                    
                                    <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container fluid>
                                            <v-row dense>
                                                <v-col cols="12" md="6">
                                                <v-autocomplete
                                                v-model="editedItem.documenttemplatetype_id"
                                                :items="documenttemplatetype_list"
                                                item-text="name"
                                                item-value="id"
                                                label="Document Template Type"
                                                outlined
                                                dense
                                                :rules="[(v) => !!v || 'Document Template Type is required']"
                                                clearable
                                                >
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                    <v-list-item-title>
                                                        No Document Template Types Loaded
                                                    </v-list-item-title>
                                                    </v-list-item>
                                                </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" class="mb-4">
                                                <v-textarea
                                                v-model="editedItem.template"
                                                label="Template"
                                                rows="10"
                                                auto-grow
                                                style="overflow-y: auto; height: 300px;"
                                                outlined
                                                ></v-textarea>
                                            </v-col>
                                             <v-col cols="12">
                                                <v-text-field
                                                dense
                                                v-model="editedItem.description"
                                                label="Description"
                                                outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6" class="d-flex align-center">
                                                <v-checkbox
                                                v-model="editedItem.isactive"
                                                color="success"
                                                label="Active"
                                                hide-details
                                                ></v-checkbox>
                                            </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save">Save</v-btn>
                                    </v-card-actions>

                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.template="{ item }">
                    <v-icon class="mr-2" size="25" color="info" @click="viewItem(item)">
                      mdi-eye
                    </v-icon>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
                        <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                    </div>
                </template>
            </v-data-table>
            <v-dialog v-model="viewDialog" max-width="800px">
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">Template Preview</span>
                </v-card-title>

                <v-card-text style="max-height: 500px; overflow-y: auto;">
                  <div>{{ viewTemplate }}</div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="viewDialog = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            { text: "Document Template Type", align: "left", sortable: false, value: "documenttemplatetype_name" },
            { text: "Template", align: "center", sortable: true, value: "template" },            
            { text: "Description", align: "left", sortable: true, value: "description" },            
            { text: "Active", align: "center", sortable: true, value: "isactive" },
            { text: "Actions",align: "center", value: "action", sortable: false },
        ],
        document_template_list: [],
        documenttemplatetype_list: [],
        editedIndex: -1,
        editedItem: {
            id: null,
            template: "",
            description: "",
            isactive: true,
            documenttemplatetype_id: null,
            documenttemplatetype_name: "",
        },
        defaultItem: {
            id: null,
            template: "",
            description: "",
            isactive: true,
            documenttemplatetype_id: null,
            documenttemplatetype_name: "",
        },
        viewDialog: false,
        viewTemplate: "",
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Document Template" : "Edit Document Template";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        viewItem(item) {
            this.viewTemplate = item.template;
            this.viewDialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .get("/Examination/getDocumentTemplate")
                .then((res) => {
                    console.log("Backend response:", res.data);
                    this.overlay = false;
                    if (res.data.document_template_list) {
                        this.document_template_list = res.data.document_template_list;
                        this.documenttemplatetype_list = res.data.documenttemplatetype_list || [];
                        console.log("Document template type list:", this.documenttemplatetype_list);
                        if (this.documenttemplatetype_list.length === 0) {
                            this.showSnackbar("#ff9800", "No document template types available");
                        }
                    } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
                        this.showSnackbar("#b71c1c", "Unauthorized access");
                    } else if (res.data.msg === "404") {
                        this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to load Document Templates");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    console.error("Axios error:", error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        editItem(item) {
            this.editedIndex = this.document_template_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            if (!confirm(`Are you sure you want to delete Document Template '${item.template}'?`)) return;
            axios
                .post("/Examination/deleteDocumentTemplate", { deleteid: item.id })
                .then((res) => {
                    if (res.data.status && res.data.status.code === "SUCCESS") {
                        this.showSnackbar("#4caf50", "Document Template Deleted Successfully");
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to delete Document Template");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    console.error(error);
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.$refs.form.resetValidation();
            }, 300);
        },

        save() {
            // Sequential validation: show only the first error
            if (!this.editedItem.template || this.editedItem.template.trim() === "") {
                this.showSnackbar("#b71c1c", "Template is required");
                return;
            }
           
            if (!this.editedItem.documenttemplatetype_id) {
                this.showSnackbar("#b71c1c", "Document Template Type is required");
                return;
            }

            const payload = {
                template: this.editedItem.template.trim(),
                description : this.editedItem.description.trim(),
                isactive: this.editedItem.isactive,
                documenttemplatetype_id: this.editedItem.documenttemplatetype_id,
            };

            if (this.editedIndex > -1) {
                // Edit
                payload.editid = this.editedItem.id;
                axios
                    .post("/Examination/editDocumentTemplate", payload)
                    .then((res) => {
                        if (res.data.status && res.data.status.code === "SUCCESS") {
                            Object.assign(this.document_template_list[this.editedIndex], this.editedItem);
                            this.showSnackbar("#4caf50", "Document Template Updated Successfully");
                            this.onLoad();
                        } else if (res.data.status && res.data.status.code === "NA") {
                            this.showSnackbar("#b71c1c", res.data.status.message);
                        } else if (res.data.msg === "404") {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to update Document Template");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            } else {
                // Save new
                axios
                    .post("/Examination/saveDocumentTemplate", payload)
                    .then((res) => {
                        if (res.data.status && res.data.status.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Document Template Added Successfully");
                            this.onLoad();
                        } else if (res.data.status && res.data.status.code === "NA") {
                            this.showSnackbar("#b71c1c", res.data.status.message);
                        } else if (res.data.msg === "404") {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to add Document Template");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            }
            this.close();
        },
    },
};
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size { font-size: 20px; }
    .edit-avatar { transition: 0.3s; border: 1px solid #b0bec5; }
    .edit-avatar:hover { background-color: #b0bec5; }
    .edit-v-icon { padding-left: 6px; font-size: 15px; }
    .edit-v-icon:hover { color: white; }
</style>